import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Modal,
  MaskedInput as Input,
  Loader,
  Section,
  withForm,
} from '@casanova/casanova-common';
import { Blank } from 'components';
import { FORM_ACTIONS } from 'utils/constants/formActions';
import i18n from '@i18n';
import _noop from 'lodash/noop';
import { config as finalConfig } from './config';
import { useFormikContext } from 'formik';

const { ADD, EDIT } = FORM_ACTIONS;

const DetailBrand = (props) => {
  const { selectedBrand = {}, action = ADD, type } = props;

  const { setFieldValue, values } = useFormikContext();

  const title = `${action === EDIT ? i18n('COMMONS__EDIT') : 'Nueva'} ${i18n(
    'COMMONS__BRAND'
  )}`;

  useEffect(() => {
    setFieldValue('action', action);
    setFieldValue('type', type);
    if (action === EDIT) {
      setFieldValue('name', selectedBrand.name);
      setFieldValue('uuid', selectedBrand.uuid);
    }
  }, [action, selectedBrand, setFieldValue]);

  return (
    <>
      <Section title={title}>
        <div className="row">
          <div className="col">
            <Input
              label={i18n('COMMONS__BRAND')}
              placeholder={i18n('COMMONS__BRAND')}
              name="name"
              upperCase
            />
          </div>
        </div>
      </Section>
    </>
  );
};

const BrandModal = (props) => {
  const {
    show = false,
    onClose = _noop,
    onSuccess,
    loader = false,
    selectedBrand = {},
    closeResponseDialog,
    responseDialog,
    action,
  } = props;

  const [hide, setHide] = useState(false);
  const [shouldDisabledSubmit, setShouldDisabledSubmit] = useState(false);

  const handleBeforeSubmit = useCallback(() => {
    setHide(true);
  }, []);

  const handleSuccess = useCallback(() => {
    setHide(false);
    onSuccess();
  }, []);

  const handleClose = useCallback(() => {
    setHide(false);
    onClose();
  }, []);

  const config = useMemo(() => {
    return {
      ...finalConfig(action),
      onBeforeSubmit: handleBeforeSubmit,
      onSuccess: handleSuccess,
      onClose: handleClose,
    };
  }, [action, handleBeforeSubmit, handleSuccess]);

  const DetailBrandWithForm = withForm({ config })(DetailBrand)({
    ...props,
    selectedBrand,
    layout: false,
    left: <Blank />,
    onCancel: handleClose,
    closeResponseDialog: () => {
      if (responseDialog.open) {
        handleSuccess();
      }
      closeResponseDialog();
    },
    disabledSubmit: shouldDisabledSubmit,
    shouldDisabledSubmit,
    setShouldDisabledSubmit,
  });

  return (
    <>
      {/* <Loader show={hide && !loader && show} /> */}
      <Modal
        open={!loader && show}
        header={null}
        footer={null}
        onClose={onClose}
        topContainerClassName={`${hide ? 'd-none' : ''}`}
        bigModal
        closeButton
      >
        {DetailBrandWithForm}
      </Modal>
    </>
  );
};

export default BrandModal;
